import {
    formatQueryParams,
    stripItmFromQueryParameters,
    toQueryParameters
} from 'tradera-utils/url';
import cookieUtil from 'tradera-utils/cookie';

import adsActions from './ads/actions';
import uiActions from './ui/actions';
import * as pushNotificationActions from './push-notifications/push-notifications-slice';
import { initializeFromInitData as initShippingRegion } from './shipping-region/actions';
import discoverActions from './discover/actions';
import { initEnvironment } from './environment/actions';
import { initialize as initLanguage } from './language/reducer';
import { initialize as initMember } from './member/actions';
import { initialize as initInitData } from './init-data/actions';
import { initialize as initMultiCurrency } from './multi-currency/reducer';
import itemsActions from './items/actions';
import pageActions from './page/actions';

// Views
import * as viewItemActions from './views/view-item/reducer';
import { handleReportItemModel } from './views/report-item/actions';
import { initialize as initStartPage } from './views/start-page/reducer';
import { initialize as initTraderaShop } from './views/tradera-shop/actions';
import { initializeFromInitData as initializeUiFromInitData } from './ui/initial-state';

export const initializeState = initData => dispatch => {
    const { isLoggedIn, featureSwitches, currencies, currencyCode } = initData;
    if (initData?.itemNext) {
        // temporary compatibility fix during migration
        // from touchweb backend to nextjs/webapi
        initData.item = initData.itemNext;
    }

    const preferredCurrency = isLoggedIn
        ? currencyCode
        : cookieUtil.readCookie('preferred_currency');
    /**
     * handle tcf + gdpr loading
     */
    if (featureSwitches?.['quantcast-consent']) {
        window.addEventListener('tcfLoaded', function() {
            dispatch(adsActions.setTcfLoaded());
        });
    } else {
        dispatch(adsActions.setTcfLoaded());
    }
    dispatch(initializeUiFromInitData(initData));
    dispatch(pushNotificationActions.init());
    dispatch(adsActions.initialize(initData));
    dispatch(initShippingRegion(initData));
    dispatch(initEnvironment(initData));
    dispatch(initLanguage(initData));
    dispatch(initMember(initData));
    dispatch(initInitData(initData));
    dispatch(
        initMultiCurrency({
            currencies,
            enabled: featureSwitches?.['multi-currency'],
            preferredCurrency
        })
    );
    dispatch(itemsActions.initialize(initData));
    dispatch(pageActions.initialize(initData));
    dispatch(initStartPage(initData));
    dispatch(initTraderaShop(initData));
    dispatch(uiActions.fetchSystemMessages());
    dispatch(discoverActions.initialize());

    /**
     *  We hydrate the store with discover results from initData
     * this will be dispatched before any rendering to reduce the time from first byte to first render.
     */
    if (initData?.discoverResponse) {
        dispatch(
            discoverActions.receiveSearchResults({
                endpoint: window.location.pathname,
                queryParams: stripItmFromQueryParameters(
                    formatQueryParams(toQueryParameters(window.location.search))
                ),
                result: initData.discoverResponse
            })
        );
    } else if (initData?.item) {
        dispatch(
            viewItemActions.handleItemModel(initData.item, initData.memberId)
        );
    } else if (initData?.reportItem) {
        dispatch(handleReportItemModel(initData.reportItem));
    } else if (initData?.traderaShopProduct) {
        dispatch(
            adsActions.setAds(
                initData.traderaShopProduct.item.reduxContainer.ads
            )
        );
    }
};
